import { SearchContainer } from "containers/SearchContainer"
import { FullHeightLayout } from "layouts/kiosk-v"
import { DiningKioskVPage } from "./pages/dining/index.kiosk-v"
import { DirectoryKioskVPage } from "./pages/directory/index.kiosk-v"
import { themeOptionFactories } from "./theme"
import { SearchPopupContent as SearchPopupKioskVContent } from "./components/domains/search/kiosk-v/SearchPopupContent"

//mobile
import { AttractionsPage } from "./pages/attractions"
import { LuxuryPage } from "./pages/luxury"
import { SearchContainer as MobileSearchContainer } from "./components/domains/search/SearchContainer"
import { SearchPopupContent } from "./components/domains/search/SearchPopupContent"
import { ServicesPage } from "extensions/iconsiam/pages/services"
import { Directory } from "./pages/directory"
import { DiningPage } from "./pages/dining"
import { Events } from "./pages/events"
import { EventDetail } from "./pages/events/[eventId]"
import { Promotions } from "./pages/promotions"
import { PromotionDetail } from "./pages/promotions/[promotionId]"
import { MapOrdinal } from "./pages/maps/[ordinal]"
import { PlaceDetailPage } from "./pages/maps/place/[placeId]"
import { ReservationPage } from "./pages/maps/place/[placeId]/reservation"
import { ServiceDetailPage } from "./pages/services/[serviceId]"
import { DirectionLayout } from "pages/maps/dir/[origin]/[destination]/_layout"
import { DirectionOverviewPage } from "./pages/maps/dir/[origin]/[destination]"
import { StepByStep } from "./pages/maps/dir/[origin]/[destination]/navigate/steps/[step]"
import { FeatureByCategory } from "./pages/maps/[featureType]/[category]"

//kiosk-v
import { LoadingScreen } from "./components/LoadingScreen"
import { HomePage as HomeKioskVPage } from "./pages/home/index.kiosk-v"
import { LuxuryKioskVPage } from "./pages/luxury/index.kiosk-v"
import { LuxuryDetailKioskVPage } from "./pages/luxury/[luxuryId].kiosk-v"
import { MapOrdinalKioskVPage } from "./pages/maps/[ordinal].kiosk-v"
import { EventsKioskVPage } from "./pages/events/index.kiosk-v"
import { EventDetailKioskVPage } from "./pages/events/[eventId].kiosk-v"
import { PromotionsKioskVPage } from "./pages/promotions/index.kiosk-v"
import { OccupantPromotionKioskVPage } from "./pages/promotions/occupant"
import { PromotionDetailKioskVPage } from "./pages/promotions/[promotionId].kiosk-v"
import { ServicesKioskVPage } from "./pages/services/index.kiosk-v"
import { AppNavigation as AppKioskVNavigation } from "./containers/kiosk-v"
import { PlaceDetailKioskVPage } from "./pages/maps/place/[placeId]/index.kiosk-v"
import { DirectionLayoutKioskVPage } from "pages/maps/dir/[origin]/[destination]/_layout.kiosk-v"
import { DirectionOverviewKioskVPage } from "./pages/maps/dir/[origin]/[destination]/index.kiosk-v"
import { FeatureByCategoryKioskVPage } from "./pages/maps/[featureType]/[category].kiosk-v"
import { StepByStepKioskVPage } from "./pages/maps/dir/[origin]/[destination]/navigate/steps/[step]/index.kiosk-v"

//kiosk-h
import { AppNavigation as AppKioskHNavigation } from "./containers/kiosk-h"
import { MapOrdinalKioskHPage } from "./pages/maps/[ordinal].kiosk-h"
import { ContentWithAside, MapPageLayout } from "layouts/kiosk-h"
import { DirectoryKioskHPage } from "./pages/directory/index.kiosk-h"
import { FeatureByCategoryKioskHPage } from "./pages/maps/[featureType]/[category].kiosk-h"
import { StepByStepKioskHPage } from "./pages/maps/dir/[origin]/[destination]/navigate/steps/[step]/index.kiosk-h"
import { DirectionOverviewKioskHPage } from "./pages/maps/dir/[origin]/[destination]/index.kiosk-h"
import { DirectionLayoutKioskHPage } from "pages/maps/dir/[origin]/[destination]/_layout.kiosk-h"
import { PlaceDetailKioskHPage } from "./pages/maps/place/[placeId]/index.kiosk-h"
import { EventDetailKioskHPage } from "./pages/events/[eventId].kiosk-h"
import { OccupantPromotionKioskHPage } from "./pages/promotions/occupant"
import { ServicesKioskHPage } from "./pages/services/index.kiosk-h"
import { LuxuryKioskHPage } from "./pages/luxury/index.kiosk-h"
import { LuxuryDetailKioskHPage } from "./pages/luxury/[luxuryId].kiosk-h"
import { DiningKioskHPage } from "./pages/dining/index.kiosk-h"
import { HomePage as HomePageKioskHPage } from "./pages/home/index.kiosk-h"
import { PromotionsKioskHPage } from "./pages/promotions/index.kiosk-h"
import { PromotionDetailKioskHPage } from "./pages/promotions/[promotionId].kiosk-h"
import { EventsKioskHPage } from "./pages/events/index.kiosh-h"
import { OccupantRecommendedMenuKioskHPage } from "./pages/maps/place/[placeId]/recommended-menu/index.kiosk-h"
import { OccupantReservationKioskHPage } from "./pages/maps/place/[placeId]/reservation/index.kiosk-h"
import { OccupantPromotionDetailKioskHPage } from "./pages/promotions/occupant/[promotionId].kiosk-h"
import { SearchPopupContent as SearchPopupKioskHContent } from "./components/domains/search/kiosk-h/SearchPopupContent"

export const iconSiam = {
  themeOptionFactories,
  ignoreAppThemeFactory: false,

  appLayoutConfig: {
    "kiosk-v": {
      search: <SearchContainer renderComponent={SearchPopupKioskVContent} />,
      appNavigation: <AppKioskVNavigation />,
    },
    "kiosk-h": {
      search: <SearchContainer renderComponent={SearchPopupKioskHContent} />,
      appNavigation: <AppKioskHNavigation />,
    },
    mobile: {
      search: <MobileSearchContainer renderComponent={SearchPopupContent} />,
    },
  },
  appComponents: {
    "kiosk-v": {
      loadingScreen: <LoadingScreen />,
    },
    "kiosk-h": {
      loadingScreen: <LoadingScreen />,
    },
  },
  routes: {
    mobile: [
      {
        path: "luxury",
        element: <LuxuryPage />,
      },

      {
        path: "attractions",
        element: <AttractionsPage />,
      },
      {
        path: "services",
        element: <ServicesPage />,
      },
      {
        path: "services/:serviceId",
        element: <ServiceDetailPage />,
      },
      {
        path: "directory",
        element: <Directory />,
      },
      {
        path: "dining",
        element: <DiningPage />,
      },
      {
        path: "events",
        element: <Events />,
      },
      {
        path: "events/:eventId",
        element: <EventDetail />,
      },
      {
        path: "promotions",
        element: <Promotions />,
      },
      {
        path: "promotions/:promotionId",
        element: <PromotionDetail />,
      },
      {
        type: "map",
        path: "ordinal/:ordinal",
        element: <MapOrdinal />,
      },
      {
        type: "map",
        path: "place/:placeId",
        element: <PlaceDetailPage />,
      },
      {
        path: "maps/place/:placeId/reservation",
        element: <ReservationPage />,
      },
      {
        type: "map",
        path: "dir/:origin/:destination",
        element: <DirectionLayout />,
        children: [
          {
            index: true,
            element: <DirectionOverviewPage />,
          },
          {
            path: "navigate/steps/:step",
            element: <StepByStep />,
          },
        ],
      },
      {
        type: "map",
        path: ":featureType/:category",
        element: <FeatureByCategory />,
      },
    ],
    "kiosk-v": [
      {
        path: "directory",
        element: (
          <DirectoryKioskVPage
            Layout={FullHeightLayout}
            AppNavigation={false}
          />
        ),
      },
      {
        path: "events",
        element: (
          <EventsKioskVPage Layout={FullHeightLayout} AppNavigation={false} />
        ),
      },
      {
        path: "events/:eventId",
        element: (
          <EventDetailKioskVPage
            Layout={FullHeightLayout}
            AppNavigation={false}
          />
        ),
      },
      {
        path: "promotions",
        element: (
          <PromotionsKioskVPage
            Layout={FullHeightLayout}
            AppNavigation={false}
          />
        ),
      },
      {
        path: "promotions/occupant/:occupantId",
        element: (
          <OccupantPromotionKioskVPage
            Layout={FullHeightLayout}
            AppNavigation={false}
          />
        ),
      },
      {
        path: "promotions/:promotionId",
        element: (
          <PromotionDetailKioskVPage
            Layout={FullHeightLayout}
            AppNavigation={false}
          />
        ),
      },
      {
        path: "dining",
        element: (
          <DiningKioskVPage Layout={FullHeightLayout} AppNavigation={false} />
        ),
      },
      {
        path: "services",
        element: (
          <ServicesKioskVPage Layout={FullHeightLayout} AppNavigation={false} />
        ),
      },
      {
        path: "luxury",
        element: (
          <LuxuryKioskVPage Layout={FullHeightLayout} AppNavigation={false} />
        ),
      },
      {
        path: "luxury/:luxuryId",
        element: (
          <LuxuryDetailKioskVPage
            Layout={FullHeightLayout}
            AppNavigation={false}
          />
        ),
      },
      {
        type: "base",
        element: <HomeKioskVPage Layout={FullHeightLayout} />,
        index: true,
      },
      {
        type: "map",
        path: "ordinal/:ordinal",
        element: (
          <MapOrdinalKioskVPage
            Layout={FullHeightLayout}
            AppNavigation={false}
          />
        ),
      },
      {
        type: "map",
        path: "place/:placeId",
        element: <PlaceDetailKioskVPage />,
      },
      {
        type: "map",
        path: "dir/:origin/:destination",
        element: <DirectionLayoutKioskVPage />,
        children: [
          {
            index: true,
            element: <DirectionOverviewKioskVPage />,
          },
          {
            path: "navigate/steps/:step",
            element: <StepByStepKioskVPage />,
          },
        ],
      },
      {
        type: "map",
        path: ":featureType/:category",
        element: (
          <FeatureByCategoryKioskVPage
            Layout={FullHeightLayout}
            AppNavigation={false}
          />
        ),
      },
    ],
    "kiosk-h": [
      //TODO:: add extension page later (WIP)
      {
        type: "base",
        index: true,
        element: (
          <HomePageKioskHPage Layout={ContentWithAside} AppNavigation={false} />
        ),
        options: {
          showAppLayoutNav: true,
        },
      },
      /**
       * Page Routes (kiosk-h)
       */
      {
        path: "events",
        element: (
          //TODO:: add extension page later (WIP)
          <EventsKioskHPage Layout={ContentWithAside} AppNavigation={false} />
        ),
      },
      {
        path: "events/:eventId",
        element: (
          <EventDetailKioskHPage
            Layout={ContentWithAside}
            AppNavigation={false}
          />
        ),
      },
      {
        path: "promotions",
        element: (
          <PromotionsKioskHPage
            Layout={ContentWithAside}
            AppNavigation={false}
          />
        ),
      },
      {
        path: "promotions/occupant/:occupantId",
        element: (
          <OccupantPromotionKioskHPage
            Layout={ContentWithAside}
            AppNavigation={false}
          />
        ),
        options: {
          showAppLayoutNav: false,
        },
      },
      {
        // Temporary fix: display sidebar menu without AppNavigation overlay by adding a new route and setting showAppLayoutNav to false
        path: "occupant-promotions/:promotionId",
        element: (
          <OccupantPromotionDetailKioskHPage
            Layout={ContentWithAside}
            AppNavigation={false}
          />
        ),
        options: {
          showAppLayoutNav: false,
        },
      },
      {
        path: "promotions/:promotionId",
        element: (
          <PromotionDetailKioskHPage
            Layout={ContentWithAside}
            AppNavigation={false}
          />
        ),
      },
      {
        path: "directory",
        element: (
          <DirectoryKioskHPage
            Layout={ContentWithAside}
            AppNavigation={false}
          />
        ),
      },
      {
        path: "services",
        element: (
          //TODO:: add extension page later (WIP)
          <ServicesKioskHPage Layout={ContentWithAside} AppNavigation={false} />
        ),
      },
      {
        path: "luxury",
        element: (
          //TODO:: add extension page later (WIP)
          <LuxuryKioskHPage Layout={ContentWithAside} AppNavigation={false} />
        ),
      },
      {
        path: "luxury/:luxuryId",
        element: (
          <LuxuryDetailKioskHPage
            Layout={ContentWithAside}
            AppNavigation={false}
          />
        ),
      },
      {
        path: "dining",
        element: (
          <DiningKioskHPage Layout={ContentWithAside} AppNavigation={false} />
        ),
      },
      /**
       * Map Routes (kiosk-h)
       */
      {
        type: "map",
        path: "ordinal/:ordinal",
        element: (
          <MapOrdinalKioskHPage Layout={MapPageLayout} AppNavigation={false} />
        ),
      },
      {
        type: "map",
        path: "place/:placeId",
        //TODO:: add extension page later (WIP)
        element: <PlaceDetailKioskHPage Layout={MapPageLayout} />,
      },
      {
        type: "map",
        path: "place/:placeId/recommended-menu",
        element: <OccupantRecommendedMenuKioskHPage Layout={MapPageLayout} />,
        options: {
          showAppLayoutNav: false,
        },
      },
      {
        type: "map",
        path: "place/:placeId/reservations",
        element: <OccupantReservationKioskHPage Layout={MapPageLayout} />,
        options: {
          showAppLayoutNav: false,
        },
      },
      {
        type: "map",
        path: "dir/:origin/:destination",
        //TODO:: add extension page later (WIP)
        element: <DirectionLayoutKioskHPage />,
        children: [
          {
            index: true,
            element: <DirectionOverviewKioskHPage Layout={MapPageLayout} />,
          },
          {
            path: "navigate/steps/:step",
            element: <StepByStepKioskHPage Layout={MapPageLayout} />,
          },
        ],
      },
      {
        type: "map",
        path: ":featureType/:category",
        element: (
          <FeatureByCategoryKioskHPage
            Layout={MapPageLayout}
            AppNavigation={false}
          />
        ),
      },
    ],
  },
}
